import React from "react";
import WishlistButton from "./WishlistButton";
function Electronics(){
    return (<div className="Electronics"> 
        
       
        <div className ="card">
        <div className="catalog-section-title"><h1>Television</h1></div>
        <div className="row">

            <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/electronicsimages/Samsung 80cm (32 inch) HD Ready LED TV.jpeg"}alt="" />
       </div>
       <div className="card-header">
<h6>Samsung 80cm (32 inch) HD Ready LED TV </h6>
<p>Samsung 80cm (32 inch) HD Ready LED TV  (UA32T4010ARXXL)</p>
<h4> ₹12,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>
       
         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Samsung 108cm (43 inch) Full HD LED Smart TV.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Samsung 108cm (43 inch) Full HD LED Smart TV  </h6><p>Samsung 108cm (43 inch) Full HD LED Smart TV  (UA43N5300ARLXL/UA43N5300ARXXL)</p><h4> ₹34,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>

          <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Samsung 123cm (49 inch) Full HD LED Smart TV.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Samsung 123cm (49 inch) Full HD LED Smart TV </h6><p>Samsung 123cm (49 inch) Full HD LED Smart TV  (UA49N5300ARXXL)</p><h4> ₹44,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>
       
         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/LG 108cm (43 inch) Full HD LED Smart TV.jpeg"} alt="" /></div>
       <div className="card-header"><h6>LG 108cm (43 inch) Full HD LED Smart TV  </h6><p>LG 108cm (43 inch) Full HD LED Smart TV  (43LM6360PTB)</p><h4> ₹34,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>

         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/LG All-in-One 126cm (50 inch) Ultra HD (4K) LED Smart TV.jpeg"} alt="" /></div>
       <div className="card-header"><h6>LG All-in-One 126cm (50 inch) Ultra HD (4K) LED Smart TV</h6><p>LG All-in-One 126cm (50 inch) Ultra HD (4K) LED Smart TV  (50UM7290PTD)</p><h4> ₹44,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>

         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/LG 108cm (43 inch) Ultra HD (4K) LED Smart TV.jpeg"}alt=""  /></div>
       <div className="card-header"><h6>LG 108cm (43 inch) Ultra HD (4K) LED Smart TV </h6><p>LG 108cm (43 inch) Ultra HD (4K) LED Smart TV  (43UK6780PTE)</p><h4> ₹47,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>
        </div>   
        </div>


        <div className ="card">
        <div className="catalog-section-title"><h1>Washing Machine</h1></div>
        <div className="row">
         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Intex 6.2 kg Semi Automatic Top Load Red.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Intex 6.2 kg Semi Automatic Top Load Red </h6><p>Intex 6.2 kg Semi Automatic Top Load Red  (WMS62TL)</p><h4> ₹8,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>
        
          <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/IFB 6 kg 2D Wash Fully Automatic Front Load with In-built Heater White.jpeg"} alt="" /></div>
       <div className="card-header"><h6>IFB 6 kg 2D Wash Fully Automatic Front Load with In-built Heater White </h6><p>IFB 6 kg 2D Automatic Front Load(Diva Aqua VX)</p><h4> ₹20,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>

         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Bosch 6 kg Fully Automatic Front Load with In-built Heater White.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Bosch 6 kg Fully Automatic Front Load with In-built Heater White</h6><p>Bosch 6 kg Fully Automatic Front Load(WAB16060IN)</p><h4> ₹20,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>
         </div>
        </div>

        
        <div className ="card">
        <div className="catalog-section-title"><h1>Refrigerators</h1></div>
        <div className="row">
         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Godrej 231 L Frost Free Double Door 1 Star (2020) Refrigerator.jpeg"}alt=""  /></div>
       <div className="card-header"><h6>Godrej 236 L Frost Free Double Door 2 Star (2020) Refrigerator </h6><p>Reciprocatory Compressor|1 Star|Toughened Glass Shelves|231 L</p><h4> ₹16,790 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>

         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Godrej 236 L Frost Free Double Door 2 Star (2020) Refrigerator.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Godrej 236 L Frost Free Double Door 2 Star (2020) Refrigerator </h6><p>RGodrej 236 L Frost Free Double Door 2 Star (2020) Refrigerator  (Sleek Steel, RF EON 236B 25 HI SI ST)</p><h4> ₹17,990 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>

         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Godrej 231 L Frost Free Double Door 2 Star (2016) Refrigerator.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Godrej 231 L Frost Free Double Door 2 Star (2016) Refrigerator </h6><p>Godrej 231 L Frost Free Double Door 2 Star (2016) Refrigerator  (Silver Strokes, RT EON 231 C 2.4)</p><h4> ₹19,099 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>
        </div>
        </div>


        <div className ="card">
        <div className="catalog-section-title"><h1>Air Conditioner</h1></div>
        <div className="row">
         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Blue Star 1.2 Ton 3 Star Split Inverter AC - White.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Blue Star 1.2 Ton 3 Star Split Inverter AC - White  </h6><p>Blue Star 1.2 Ton 3 Star Split Inverter AC - White  (IC315AATU, Copper Condenser)</p><h4> ₹31,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>
       
         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Whirlpool 0.8 Ton 3 Star Split Inverter AC - White.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Whirlpool 0.8 Ton 3 Star Split Inverter AC - White </h6><p>Whirlpool 0.8 Ton 3 Star Split Inverter AC - White  (0.8T 3S COPR-W-I/ODU, Copper Condenser)</p>
<h4> ₹23,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>

         <div className="pricing-column col-lg-4 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/electronicsimages/Onida 1 Ton 3 Star Split Inverter AC - White.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Onida 1 Ton 3 Star Split Inverter AC - White  </h6><p>Onida 1 Ton 3 Star Split Inverter AC - White  (IR123RHO, Copper Condenser)</p><h4> ₹25,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>
        </div>
        </div>

</div>)
}

export default Electronics;